export const updateChapterStep = (chapters, currentChapter, step) => {
  chapters.forEach((chapter) => {
    if (chapter.id === currentChapter.id) {
      chapter.step = step;
      return;
    } else {
      return;
    }
  });

  return chapters;
};
